import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import {Grid, Button} from 'react-bootstrap'
import PageTitle from '../../../common/page-title'
import UsersList from './users-list'
import {getUsers} from '../../../../actions/users'
import {actions} from 'react-redux-form'

import './styles.css'
import UsersSearch from "./users-search";
import ArrowButton from '../../../common/button-arrow';

class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      status: '',
      userGroup: '',
      pageNumber: 1
    }
  }

  componentWillMount() {
    this.handleSearch();
  }

  handleInputChange = (e) => {
    this.setState({query: e.target.value});
  };

  handleStatusFilterChange = (e) => {
    this.setState({status: e.target.value});
  };

  handleGroupFilterChange = (e) => {
    this.setState({userGroup: e.target.value});
  };

  handleSearch = () => {
    const {
      query, userGroup, status, pageNumber
    } = this.state;
    this.props.dispatch(getUsers(query, userGroup, status, pageNumber));
  };

  handleClear = () => {
    this.setState({
      query: '',
      userGroup: '',
      status: '',
      pageNumber: 1
    }, this.handleSearch);
  };

  handlePageChange = (page) => {
    this.setState({pageNumber: page}, this.handleSearch);
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="users">
        <PageTitle>
          Users
        </PageTitle>
        <Link to="/admin/users/new">
          <ArrowButton
            submit={false}
            arrow={false}
            className="add-user"
            permissions={{
              action:       'create',
              subjectClass: 'User'
            }}
          >
            Add user
          </ArrowButton>
        </Link>

        <UsersSearch
          searchValue={this.state.query}
          userGroupFilterValue={this.state.userGroup}
          statusFilterValue={this.state.status}
          userGroups={this.props.userGroups}
          statuses={this.props.statuses}
          onInputChange={this.handleInputChange}
          onStatusFilterChange={this.handleStatusFilterChange}
          onUserGroupFilterChange={this.handleGroupFilterChange}
          onSearch={this.handleSearch}
          onClear={this.handleClear}
        />
        <UsersList
          users={this.props.users}
          fetching={this.props.fetching}
          fetched={this.props.fetched}
          currentPage={this.state.pageNumber}
          onPageChange={this.handlePageChange}
          paging={this.props.paging}
        />
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    users: state.users.users,
    fetched: state.users.fetched,
    fetching: state.users.fetching,
    userGroups: state.users.listInput.userGroups,
    statuses: state.users.listInput.statuses,
    paging: state.users.paging
  };
};

export default connect(mapStateToProps)(Users);


// WEBPACK FOOTER //
// ./src/components/admin/users/list/index.jsx